/**
 * Centralized branding constants for StockBAI
 * Used across the application for consistent branding
 */

export const BRAND_NAME = "StockBAI";
export const BRAND_TAGLINE = "Repeatable scans. Chart-first review.";
export const BRAND_FULL = "StockBAI - Technical screening for global stocks & ETFs";
export const BRAND_DESCRIPTION =
  "StockBAI is a technical-screening workspace for active traders. " +
  "Build a repeatable scan from ~20 modular filters or load a preset strategy like 150 MA System, " +
  "review every match in a chart-first workspace with full Deep Analysis, " +
  "and get notified the moment price retests a key moving average. " +
  "Universe of 7,000+ global stocks & ETFs (market cap > $300M). " +
  "Optional Perplexity and Grok X analysis for context. Multilingual (EN/HE/AR/RU). Not investment advice.";

// SEO defaults
export const SEO_DEFAULTS = {
  title: "StockBAI - Technical Stock Screener for Global Stocks & ETFs",
  description:
    "Run repeatable technical scans on 7,000+ global stocks and ETFs (market cap > $300M). " +
    "~20 filters, preset strategies like 150 MA System, chart-first review, MA-touch alerts, optional AI analysis.",
  keywords:
    "stock screener, technical screening, global stocks, ETFs, moving averages, MA touch alerts, RSI, " +
    "volume surge, support retest, swing trading, day trading, Perplexity AI, Grok sentiment, " +
    "multi-language stock analysis",
  canonicalUrl: "https://stockbai.com",
  ogImage: "https://stockbai.com/og-image.svg",
  twitterHandle: "@stockbai",
};

// App version - injected at build time via REACT_APP_BUILD_VERSION
export const APP_VERSION =
  process.env.REACT_APP_BUILD_VERSION || "2026.06.13";
